<template>
  <footer class="home3 main-footer wf100">
    <div class="container">
      <div class="min_screen">
        <div
          class="d-flex justify-content-evenly justify-content-center flex-wrap"
        >
          <!--Footer Widget Start-->
          <div class="col-md-3 col-sm-6">
            <div class="textwidget">
              <img
                @click="$router.replace('/')"
                class="bg-white rounded cursor_pointer"
                height="110px"
                width="290px"
                :src="require('@/assets/images/logo/ngo-logo.png')"
                alt=""
              />
            </div>
          </div>
          <!--Footer Widget End-->
          <!--Footer Widget Start-->
          <div class="col-md-3 col-sm-6 min_whidth_300">
            <div class="footer-widget">
              <h6>{{ $t("importantLinks") }}</h6>
              <ul>
                <li v-for="link in links" :key="link.label">
                  <a target="_blank" :href="link.href">{{ link.label }}</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-md-3 col-sm-6 min_whidth_300">
            <div class="footer-widget">
              <h6>{{ $t("help") }}</h6>
              <ul>
                <li v-for="link in extraLinks" :key="link.label">
                  <router-link :to="link.href">{{ link.label }}</router-link>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-md-3 col-sm-6 min_whidth_300">
            <div class="footer-widget">
              <h6>{{ $t("contactInformationWithTheMinistry") }}</h6>
              <address class="text-white">
                <ul>
                  <li>
                    <feather-icon icon="MapPinIcon" class="mx-25" />
                    شارع الثورة , مقابل سوق الخجا
                  </li>
                  <li>
                    <feather-icon icon="MailIcon" class="mx-25" />
                    <strong>البريد الالكتروني:</strong>
                    <a
                      href="mailto:info@mosal.gov.sy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      info@mosal.gov.sy</a
                    >
                  </li>
                  <li>
                    <feather-icon icon="PhoneCallIcon" class="mx-25" />
                    <strong>اتصل بنا:</strong>
                    <a
                      href="tel:0112314151"
                      target="_blank"
                      rel="noopener noreferrer"
                      >0112314151</a
                    >
                    /
                    <a
                      href="tel:0112325221"
                      target="_blank"
                      rel="noopener noreferrer"
                      >0112325221</a
                    >
                  </li>
                </ul>
              </address>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          label: "موقع رئاسة مجلس الوزراء",
          href: "http://www.pministry.gov.sy/",
        },
        {
          label: this.$t("MSALwebsite"),
          href: "https://www.facebook.com/mosal.syria",
        },

        {
          label: "موقع وزارة التربية و التعليم",
          href: "http://moed.gov.sy",
        },
        {
          label: "موقع وزارة الصحة",
          href: "https://www.moh.gov.sy/",
        },
      ],
      extraLinks: [
        {
          label: this.$t("faq"),
          href: "/faq",
        },
        {
          label: "سياسة الاستخدام",
          href: "/use-policy",
        },
      ],
    };
  },
};
</script>

<style scoped>
@media (max-width: 576px) {
  .min_whidth_300 {
    min-width: 300px;
  }
  .min_screen {
    text-align: center;
  }
}
</style>
